<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="card mb-4">
          <div class="card-header pb-0">
            <h4>Diete</h4>
            <button type="button" id="add-btn" class="btn btn-primary" @click="openDietForm">+ Nuovo</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <ul
              class="p-1 bg-transparent nav nav-pills nav-fill"
              role="tablist"
              style="max-width: 400px; margin: auto;"
            >
              <li class="nav-item">
                <a
                  class="px-0 py-1 mb-0 nav-link active"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  :class="{ active: activeTab === 'inprogress' }"
                  @click="setActiveTab('inprogress')"
                >
                  <span class="ms-1">In Corso</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="px-0 py-1 mb-0 nav-link"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="false"
                  :class="{ active: activeTab === 'future' }"
                  @click="setActiveTab('future')"
                >
                  <span class="ms-1">Futuro</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="px-0 py-1 mb-0 nav-link"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  @click="setActiveTab('executed')"
                  :class="{ active: activeTab === 'executed' }"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="ms-1">Eseguito</span>
                </a>
              </li>
            </ul>
          </div>

           <custom-table ref="table$" :rows="data" @action="runAction" :columns="[
                {
                    title: 'Alimento',
                    type: 'text',
                    data: 'food.name',
                },
                {
                    title: 'Quantità',
                    type: 'text',
                    data: 'quantity',
                },
                {
                    title: 'Unità di misura',
                    type: 'text',
                    data: 'measure_unity',
                },
                {
                    title: 'Numero di volte al giorno',
                    type: 'text',
                    data: 'number_of_times_a_day',
                },
                {
                    title: 'Da',
                    type: 'date',
                    data: 'from_date',
                },
                {
                    title: 'Al',
                    type: 'date',
                    data: 'to_date',
                },
            ]" :actions="[
                {
                    title: 'Modifica',
                    tooltip: 'edit',
                    key: 'edit',
                },
            ]"
              :pagination="pagination"
              @page-changed="handlePageChange"
              @update-pagination="handlePaginationUpdate"
              @search-changed="handleSearchChange"
             />

        </div>
    </div>
  </div>
  </div>
  

  <modal title="Dieta" v-model="dietForm">

    <Vueform ref="form$" v-model="diet" sync>
            <HiddenElement name="id" />

            <HiddenElement name="horse_diet_timetables" />

            <div class="row">
              <div class="col-10">
                <SelectElement
                    name="food_type"
                    :native="false"
                    @select="chnageFoodType"
                    label="Tipo di alimento"
                    :items="food_types"
                  />
              </div>
              <div class="col-2 text-right">
                <button type="button" class="btn btn-success add-btn mt-4"  @click="foodTypeModal=1">+</button>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <SelectElement
                  name="producer"
                  @select="changeProducer"
                  :native="false"
                  label="Produttore"
                  :items="producers"
                />
              </div>
              <div class="col-2 text-right">
                <button type="button" class="btn btn-success add-btn mt-4"  @click="producerModal=1">+</button>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <SelectElement
                  name="food_id"
                  :native="false"
                  label="Alimento"
                  rules="required"
                  :items="foods"
                />
              </div>
              <div class="col-2 text-right">
                <button type="button" class="btn btn-success add-btn mt-4"  @click="foodModal=1">+</button>
              </div>
            </div>

            <TextElement name="quantity" label="Quantità" rules="required|numeric" />
            <SelectElement
                name="measure_unity"
                :native="false"
                label="Unità di misura"
                rules="required"
                :items="['kg', 'g', 'pz']"
            />
            <TextElement name="number_of_times_a_day" label="Numero di volte al giorno" rules="required|integer" />
            <DateElement name="from_date" label="Da" rules="required"></DateElement>
            <DateElement name="to_date" label="Al" rules="required"></DateElement>

            <div style="margin-bottom: 1em;border-bottom: 1px solid #eee; padding: 1em;">

              <div style="display: flex; justify-content: space-between">
                <h5>Somministrazione</h5>
                <button type="button" id="add-timetable" class="btn btn-success add-btn mt-4"  @click="openTimeTable = 1">+</button>
              </div>

              <div v-for="(t, index) in diet.horse_diet_timetables" :key="index" style="display: flex; justify-content: space-between" >
                <div><strong>{{ this.$moment(t.time).utc().format('HH:mm') }}</strong> - {{ t.days }}</div>
                <font-awesome-icon @click="deleteTimeTable(index)" :icon="faTrash" color="red" />
              </div>

            </div>

            <button type="button" class="btn btn-secondary" @click="dietForm = 0">Chiudi</button>
          &nbsp;<button type="button" class="btn btn-primary" :class="{ loading: loading }"  @click="save">Salva</button>

          </Vueform>

  </modal>

  <modal title="Add TimeTable" v-model="openTimeTable">

    <Vueform ref="formTimeTable$">
            
            <DateElement :date="false" :time="true" name="time" rules="required" />

            <CheckboxgroupElement
              rules="required"
              name="days"
              :items="[
                'lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom'
              ]"
            />

            <button type="button" id="close" class="btn btn-secondary" @click="openTimeTable = 0">Chiudi</button>
            &nbsp;<button type="button" class="btn btn-primary"  @click="addTimeTable">Salva</button>
    </Vueform>

  </modal>

  <modal title="Nuovo tipo alimento" v-model="foodTypeModal">

    <Vueform ref="foodType$">
            <TextElement name="name" label="Nome" rules="required" />
            <button type="button" id="close" class="btn btn-secondary" @click="foodTypeModal = 0">Chiudi</button>
            &nbsp;<button type="button" class="btn btn-primary"  @click="addFoodType">Salva</button>
    </Vueform>

  </modal>

  <modal title="NUovo produttore" v-model="producerModal">

    <Vueform ref="producer$">
            <TextElement name="name" label="Nome" rules="required" />
            <button type="button" id="close" class="btn btn-secondary" @click="producerModal = 0">Chiudi</button>
            &nbsp;<button type="button" class="btn btn-primary"  @click="addProducer">Salva</button>
    </Vueform>

  </modal>

  <modal title="Alimento" v-model="foodModal">

  <Vueform ref="food$">
          <TextElement name="name" label="Nome" rules="required" />
          <button type="button" id="close" class="btn btn-secondary" @click="foodModal = 0">Chiudi</button>
          &nbsp;<button type="button" class="btn btn-primary"  @click="addFood">Salva</button>
  </Vueform>

  </modal>

  </template>
  
  
  <script>
  
  import {horsesDietService} from "@/services/HorsesDietService";
  import {useTableData} from "@/composables/useTableData";
  import CustomTable from "@/components/CustomTable";
  import { useToast } from "vue-toastification";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
  import { faTrash } from "@fortawesome/free-solid-svg-icons";
  import setNavPills from "@/assets/js/nav-pills.js";
  import Modal from "@/components/Modal";
  const toast = useToast();
  
  export default {
    name: "HorseDiets",
    props: {
      id: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        activeTab: 'inprogress',
        loading: false,
        diet: {horse_diet_timetables: []},
        foods: [],
        food_types: [],
        producers: [],
        faTrash,
        openTimeTable: 0,
        dietForm: 0,
        foodTypeModal: 0,
        producerModal: 0,
        foodModal: 0,
      };
    },
    setup(){
      return useTableData(
          horsesDietService.getHorseDiets.bind(horsesDietService),
          10
      );
    },
  created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } }
    ]);
  },
    mounted(){
      this.fetchData({horse_id: this.id, status: this.activeTab});
      setNavPills();
      horsesDietService.getFoodTypes().then(food_types => this.food_types = food_types.map(t => ({value: t.id, label: t.name})));
    },
    computed: {
    },
    components: {
      CustomTable,
      FontAwesomeIcon,
      Modal,
    },
    methods: {
      async runAction({action, row}){
        this.loading = true;
        if(action.key == 'edit'){
          horsesDietService.getHorseDietById(row.id).then((diet) => {
              // load select hierarchy
            this.diet = diet;
            this.diet.food_type = diet.food.food_type_producer.food_type_id;
            this.loadProducers(this.diet.food_type);
            this.diet.producer = diet.food.food_type_producer.id;
            this.loadFoods(this.diet.producer);
            this.diet.food_id = diet.food.id;
            this.loading=false;
            this.dietForm = 1;
          });
        }
      },
      async chnageFoodType(){
        console.log('change2')
        const food_type = this.$refs.form$.data.food_type;
        this.$refs.form$.elements$.producer?.clear('');
        this.$refs.form$.elements$.food_id?.clear('');
        if(food_type) this.loadProducers(food_type);
        this.foods = [];
      },
      async changeProducer(){
        console.log('change1')
        const producer = this.$refs.form$.data.producer;
        this.$refs.form$.elements$.food_id?.clear('');
        if(producer) this.loadFoods(producer);
      },
      async loadProducers(food_type){
        console.log('load_producer')
        horsesDietService.getProducers(food_type).then(producers => this.producers = producers.map(p => ({value: p.id, label: p.producer.name})));
      },
      async loadFoods(producer){
        console.log('load_food')
        horsesDietService.getFoods(producer).then(foods => this.foods = foods.map(f => ({value: f.id, label: f.name})))
      },
      clear(){
        this.diet = {horse_diet_timetables: []};
        this.food_type = [];
        this.producers = [];
      },
      openDietForm(){
        this.clear();
        this.dietForm = 1;
      },
      setActiveTab(tab) {
        this.activeTab = tab;
        this.handleSearchChange('');
        this.fetchData({horse_id: this.id, status: tab});
      },
      async save(){
        const form = this.$refs.form$;
        form.validate();
        if(this.diet.id) form.data.id = this.diet.id;
        form.data.horse_id = this.id;
        if (!form.hasErrors) {
          for (const key in form.data) {
            if (form.data[key] === 'null' || form.data[key] === null) {
                delete form.data[key];
            }
          }
          this.loading=true;
          try{
            await horsesDietService.saveHorseDiet(form.data);
            toast(this.$t('operation_saved'));
            this.dietForm = 0;
            this.fetchData({horse_id: this.id, status: this.activeTab});
          }finally{
            this.loading=false;
          }
        }
      },
      addTimeTable(){
        const form = this.$refs.formTimeTable$;
        form.validate();
        if (form.hasErrors) return;
        if (!Array.isArray(this.diet.horse_diet_timetables)) {
            this.diet.horse_diet_timetables = [];
        }
        this.diet.horse_diet_timetables.push({
          time: this.$moment.utc(`${this.$moment().format('YYYY-MM-DD')} ${this.$refs.formTimeTable$.data.time}`, 'YYYY-MM-DD HH:mm').format(),
          days: this.$refs.formTimeTable$.data.days.join(',')
        })
        this.openTimeTable = 0;
      },
      async addFoodType(){
        console.log('add_food_type')
        const form = this.$refs.foodType$;
        form.validate();
        if (form.hasErrors) return;
        this.loading=true;
          try{
            const type = await horsesDietService.addFoodType(form.data.name);
            toast(this.$t('operation_saved'));
            this.food_types.push({label: type.name, value: type.id});
            this.producers = [];
            this.foods = [];
            this.$refs.form$.elements$.food_type.update(type.id);
            this.$refs.form$.elements$.producer.clear('');
            this.$refs.form$.elements$.food_id.clear('');
            this.foodTypeModal = 0;
          }finally{
            this.loading=false;
          }
      },
      async addProducer(){
        console.log('add_producer')
        const form = this.$refs.producer$;
        form.validate();
        if (form.hasErrors) return;
        if (!this.$refs.form$.data.food_type) throw new Error('Please select food type before adding a new producer.');
        this.loading=true;
          try{
            const producer = await horsesDietService.addProducer(form.data.name, this.$refs.form$.data.food_type);
            toast(this.$t('operation_saved'));
            this.producers = [...this.producers, {label: form.data.name, value: producer.id}];
            this.$refs.form$.elements$.producer.update(producer.id);
            this.$refs.form$.elements$.food_id.clear('');
            this.producerModal = 0;
            this.foods = [];
          }finally{
            this.loading=false;
          }
      },
      async addFood(){
        console.log('add_food')
        const form = this.$refs.food$;
        form.validate();
        if (form.hasErrors) return;
        if (!this.$refs.form$.data.producer) throw new Error('Please select producer before adding new food.');
        this.loading=true;
          try{
            const food = await horsesDietService.addFood(form.data.name, this.$refs.form$.data.producer);
            toast(this.$t('operation_saved'));
            this.foods = [...this.foods, {label: food.name, value: food.id}];
            this.foodModal = 0;
            this.$refs.form$.elements$.food_id.update(food.id);
          }finally{
            this.loading=false;
          }
      },
      deleteTimeTable(index){
        this.diet.horse_diet_timetables.splice(index, 1);
      }
    },
  };
  </script>
